module.exports = __webpack_public_path__ + "static/media/booking_com_social_media.1f9888c4.png";